import { keys } from "@/lib/i18n/portal";
import { PageLayout } from "@/shared/layout/PageLayout";
import { LoginForm } from "@/modules/auth/components/LoginForm";
import { useTranslations } from "@/lib/i18n/intl";
import { useLocale } from "@admin/app/locale";

export function LoginPage() {
  const t = useTranslations();
  const locale = useLocale();

  return (
    <PageLayout
      title={t(keys.auth.adminTitle)}
      subtitle={t(keys.auth.adminSubtitle)}
      logoAlt={t(keys.common.appName)}
      variant="centered"
    >
      <LoginForm locale={locale} />
    </PageLayout>
  );
}
